import type { Rule } from 'antd/es/form';
import { isBefore, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { DatePickerDateType } from 'ui';
import { getDateType } from 'ui';

export const useStartDateRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { required: true },
      {
        // eslint-disable-next-line @typescript-eslint/require-await -- we need return promise with async function
        async validator(__: unknown, value?: DatePickerDateType) {
          if (value && isBefore(startOfDay(getDateType(value)), startOfDay(new Date()))) {
            throw new Error(t('Error: Date must be in the future'));
          }
        },
      },
    ],
    [t],
  );
};
